import type React from 'react';
import { NormalButton } from '@/shared/ui';
import useLoadingMigrateConfirm from './useLoadingMigrateConfirm';

export type LoadingMigrateConfirmProps = {
  onConfirm: (e: React.MouseEvent) => Promise<void> | void;
};

/**
 * Renders the blocking screen telling the reviewer a study needs a data update before it can be processed. Pulls isLoading and handleConfirm from useLoadingMigrateConfirm and disables the update button while the migration request is in flight.
 *
 * @param onConfirm - Callback invoked to start the study data update.
 * @returns The rendered migration confirmation panel.
 */
const LoadingMigrateConfirm = ({ onConfirm }: LoadingMigrateConfirmProps) => {
  const { isLoading, handleConfirm } = useLoadingMigrateConfirm({ onConfirm });

  return (
    <div className="loading-migrate-container loading-migrate-confirm">
      <div className="loading-migrate-confirm__content">
        <div className="loading-migrate-confirm__text">
          <h2 className="loading-migrate-confirm__title">Study requires an update</h2>
          <p className="loading-migrate-confirm__description">
            This study needs a data update before it can be processed.
          </p>
        </div>
        <div className="loading-migrate-confirm__buttons">
          <NormalButton
            disabled={isLoading}
            buttonName="Update now"
            onClick={handleConfirm}
            isSaving={isLoading}
          />
        </div>
      </div>
    </div>
  );
};

export default LoadingMigrateConfirm;
